/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { PAGE_TITLE, ROUTE_TYPE } from '../../Configuration'
import { mpfRListsHttp } from '../../assets/ts/api/mpf-r-lists-http'
import { Announcement, LIST_NAME as Announcementslist } from '../../assets/ts/data/announcements'
import { COMPONENTS_CODE } from '../../assets/ts/data/common-metadata'
import { getBlobStorage } from '../../assets/ts/data/data'
import { PascodeMetadata } from '../../assets/ts/data/pascode-metadata'
import { formatUTCDateToLocal } from '../../assets/ts/date-and-time/date-and-time'
import {
  filterBy,
  generateCodeOptionOnLength,
  generateOptions,
  generateSquadronOptions,
  getFilteredItems,
  getMAJCOMCode,
  getSquadrons,
  getUniqueCodes,
  removeTags,
} from '../../assets/ts/general/general'
import Buttons from '../../components/buttons/buttons'
import InformationPageList from '../../components/information-page/information-page-list'
import TagsCloud from '../../components/tags-cloud/tags-cloud'
import useAnnouncements from '../../hooks/use-announcements'
import usePageTitle from '../../hooks/use-page-title'
import usePascodeMetadata from '../../hooks/use-pascode-metadata'
import PageHeader from '../../layouts/header/page-header'
import { MetadataContext } from '../../store/metadata-context-provider'
import { PreviousPageContext } from '../../store/previous-page-provider'
import { RoleContext } from '../../store/role-context-provider'
import { UserContext } from '../../store/user-context-provider'
import {
  ALL_SELECT_LABEL,
  ALL_SELECT_OPTION,
  ALL_SELECT_OPTION_STRING,
  ALL_SELECT_VALUE,
  ALL_SELECT_VALUE_STRING,
  NONE_SELECT_OPTION_STRING,
} from '../../utils/constants/global-constants'
import NO_RESULTS from '../../utils/constants/no-results'
import CustomSelect from '../../utils/controls/custom-select'
import InputSearch from '../../utils/controls/input-search'
import { Dropdown, optionsTypes } from '../../utils/controls/select-options-data'

interface Blobs {
  fileName: string
}
interface Attachment {
  blobs: Blobs[]
}
interface DashboardAnnouncement {
  Attachments: Attachment[]
  assignComponentCode: number
  categoryCode: number
  content: string
  eKey: string
  extra: string
  id: number
  link: string
  majcomCode: number
  postedDate: string
  section: string
  sectionCode: number
  squadron: string
  subcontent: string
  subcontent1: string
  tags: string
  title: string
}
interface IntialInputValues {
  categoryValue: number
  componentValue: number
  majcomValue: number
  sectionValue: number
  squadronValue: string
}
const Announcements = () => {
  usePageTitle(PAGE_TITLE.ANNOUNCEMENTS)
  const navigate = useNavigate()
  const location = useLocation()
  const {
    categories,
    categoryOptions,
    categoryValue,
    componentOptions,
    componentValue,
    components,
    majcomOptions,
    majcomValue,
    majcoms,
    sectionOptions,
    sectionValue,
    sections,
  } = useContext(MetadataContext)

  const { currentPage, setCurrentPage, setPreviousPage } = useContext(PreviousPageContext)
  const { AnnouncementData } = useAnnouncements({
    isArchived: false,
    isNotExpired: true,
  })
  const { userProfile } = useContext(UserContext)

  const {
    initialInquiryAndDueoutFilter,
    isAssignedComponentOwner,
    isCPOwner,
    isCSS,
    isCustomer,
    isLeadership,
    isMAJCOMOwner,
    isMPFOwner,
    isSectionChief,
    isSectionOwner,
    isSiteAdmin,
    isSupervisor,
    isTechnician,
  } = useContext(RoleContext)
  const userLoginRole = {
    CSSPASCODEFilter: initialInquiryAndDueoutFilter?.cssPASCODES,
    usersAssignedComponentCode: initialInquiryAndDueoutFilter?.assignedComponentCodeFilter,
    usersMajcomCodeFilter: initialInquiryAndDueoutFilter?.majcomCodeFilter,
    usersSectionCodeFilter: initialInquiryAndDueoutFilter?.sectionCodeFilter,
    usersServicingOrganizationFilter: initialInquiryAndDueoutFilter?.servicingOrganizationFilter,
    usersServicingOrganizationWithoutSectionFilter:
      initialInquiryAndDueoutFilter?.servicingOrganizationWithoutSectionFilter,
  }
  const [isTagActive, setIsTagActive] = useState<boolean>(false)

  const [inputValues, setInputValues] = useState({
    assignedComponentCode: location.state?.filterValues?.assignedComponentCode
      ? location.state.filterValues.assignedComponentCode
      : ALL_SELECT_VALUE,
    categoryCode: location.state?.filterValues?.categoryCode
      ? location.state.filterValues.categoryCode
      : ALL_SELECT_VALUE,
    itemKey: location.state?.itemKey ? location.state?.itemKey : '',
    majcomCode: location.state?.filterValues?.majcomCode
      ? location.state.filterValues.majcomCode
      : ALL_SELECT_VALUE,
    sectionCode: location.state?.filterValues?.sectionCode
      ? location.state.filterValues.sectionCode
      : ALL_SELECT_VALUE,
    squadron: location.state?.filterValues?.squadron
      ? location.state.filterValues.squadron
      : ALL_SELECT_VALUE_STRING,
  })

  const [intialComponentDropdown, setIntialComponentDropdown] = useState<optionsTypes[]>([
    ALL_SELECT_OPTION,
  ])
  const [intialMajcomDropdown, setIntialMajcomDropdown] = useState<optionsTypes[]>([
    ALL_SELECT_OPTION,
  ])
  const [intialSquadronDropdown, setIntialSquadronDropdown] = useState<optionsTypes[]>([
    ALL_SELECT_OPTION,
  ])
  const [intialSectionDropdown, setIntialSectionDropdown] = useState<optionsTypes[]>([
    ALL_SELECT_OPTION,
  ])
  const [intialCategoryDropdown, setIntialCategoryDropdown] = useState<optionsTypes[]>([
    ALL_SELECT_OPTION,
  ])
  const [intialInputValues, setIntialInputValues] = useState<IntialInputValues>({
    categoryValue: ALL_SELECT_VALUE,
    componentValue: ALL_SELECT_VALUE,
    majcomValue: ALL_SELECT_VALUE,
    sectionValue: ALL_SELECT_VALUE,
    squadronValue: ALL_SELECT_VALUE_STRING,
  })
  const [majcomDropDown, setMajcomDropdown] = useState<optionsTypes[]>([])
  const [squadronDropDown, setSquadronDropDown] = useState<optionsTypes[]>([])
  const [categoryDropDown, setCategoryDropDown] = useState<optionsTypes[]>([])

  const { pascodeMetadata } = usePascodeMetadata({
    IsArchived: false,
  })
  const setintialOptions = (
    componentOptions: optionsTypes[],
    majcomOptions: optionsTypes[],
    squadronOptions: optionsTypes[],
    sectionOptions: optionsTypes[],
    categoryOptions: optionsTypes[],
    ownerIntialMajcom?: optionsTypes[],
    ownerIntialSqudronOptions?: optionsTypes[]
  ) => {
    const componentProfileValue = userProfile[0].AssignedComponentCode
    const squadronValue = userProfile[0].ServicingOrganization.replace('MPF', 'FSS')
    const servicingMAJCOMCode = getMAJCOMCode(userProfile[0].ServicingMAJCOM, majcoms)
    setIntialComponentDropdown(componentOptions)
    setIntialMajcomDropdown(majcomOptions)
    setMajcomDropdown(ownerIntialMajcom ? ownerIntialMajcom : majcomOptions)
    setIntialSquadronDropdown(
      ownerIntialSqudronOptions ? ownerIntialSqudronOptions : squadronOptions
    )
    setSquadronDropDown(squadronOptions)
    setIntialSectionDropdown(sectionOptions)
    setIntialCategoryDropdown(categoryOptions)
    setCategoryDropDown(categoryOptions)
    const dropdownValues = {
      assignedComponentCode: componentProfileValue,
      categoryCode: categoryOptions?.length === 1 ? categoryOptions[0].value : ALL_SELECT_VALUE,
      majcomCode: servicingMAJCOMCode,
      sectionCode: sectionOptions.length === 1 ? sectionOptions[0].value : ALL_SELECT_VALUE,
      squadron: squadronValue,
    }
    if (componentValue) {
      const option: Dropdown[] = majcoms
        .filter(({ ParentComponentCode }) => ParentComponentCode === componentValue?.value)
        .map(({ Label, Value }) => ({ label: Label, value: Value }))
      const intialmajcomCodes = majcomOptions.map(({ value }) => value)
      const options = option.filter(({ value }) => intialmajcomCodes.includes(value as number))
      if (options.length > 1) options.unshift(ALL_SELECT_OPTION)
      const pascodes =
        majcomValue.label === ALL_SELECT_LABEL
          ? pascodeMetadata
          : pascodeMetadata.filter(({ ServicingMAJCOM }) => ServicingMAJCOM === majcomValue.label)
      const intialSquadron = ownerIntialSqudronOptions
        ? ownerIntialSqudronOptions
        : squadronOptions.map(({ value }) => (value as string).replace('FSS', 'MPF'))
      const squdrons = [
        ...new Set(
          pascodes
            .filter(({ ServicingOrganization }) =>
              intialSquadron.some(
                (squad) => squad.value.replace('FSS', 'MPF') === ServicingOrganization
              )
            )
            .map(({ ServicingOrganization }) => ServicingOrganization)
        ),
      ].sort()
      const squdronsOptions = generateSquadronOptions(squdrons)
      setSquadronDropDown(squdronsOptions as optionsTypes[])
      const squadronValue =
        squdronsOptions.length === 1
          ? (squdronsOptions[0].value as string)
          : ALL_SELECT_VALUE_STRING

      setMajcomDropdown(options as optionsTypes[])
      setInputValues((prev) => ({
        ...prev,
        assignedComponentCode: componentValue?.value,
        categoryCode: categoryValue.value,
        majcomCode: majcomValue.value,
        sectionCode: sectionValue.value,
        squadron: squadronValue,
      }))
      setIntialInputValues({
        categoryValue: dropdownValues.categoryCode as number,
        componentValue: dropdownValues.assignedComponentCode as number,
        majcomValue: dropdownValues.majcomCode as number,
        sectionValue: dropdownValues.sectionCode as number,
        squadronValue: dropdownValues.squadron as string,
      })
    } else if (sectionValue || categoryValue) {
      setInputValues((prev) => ({
        ...prev,
        AssignedComponentCode:
          componentValue === null
            ? componentOptions.length === 1
              ? componentOptions[0].value
              : -1
            : componentValue.value,
        Category: categoryValue.value,
        SectionCode: sectionValue.value,
        ServicingMAJCOMCode:
          majcomValue === null
            ? majcomOptions.length === 1
              ? majcomOptions[0].value
              : -1
            : majcomValue.value,
        squadron: squadronValue,
      }))
      setIntialInputValues({
        categoryValue: dropdownValues.categoryCode as number,
        componentValue: dropdownValues.assignedComponentCode as number,
        majcomValue: dropdownValues.majcomCode as number,
        sectionValue: dropdownValues.sectionCode as number,
        squadronValue: dropdownValues.squadron as string,
      })
    } else {
      if (!location.state?.filterValues) {
        setInputValues((prev) => ({
          ...prev,
          ...dropdownValues,
        }))
        setIntialInputValues({
          categoryValue: dropdownValues.categoryCode as number,
          componentValue: dropdownValues.assignedComponentCode as number,
          majcomValue: dropdownValues.majcomCode as number,
          sectionValue: dropdownValues.sectionCode as number,
          squadronValue: dropdownValues.squadron as string,
        })
      }
    }
  }
  useEffect(() => {
    const assignedComponentOptions = componentOptions.filter(
      ({ value }) => value !== ALL_SELECT_VALUE
    )
    if (isCPOwner || isSiteAdmin) {
      const profileComponentCode = userProfile[0].AssignedComponentCode
      const majcomCodes = majcoms
        .filter((item) => item.ParentComponentCode === profileComponentCode)
        .map((item) => item.MAJCOMCode)
      const majcomOption = generateCodeOptionOnLength(majcomOptions, majcomCodes)
      const squadrons = getSquadrons(
        pascodeMetadata,
        undefined,
        undefined,
        userProfile[0].ServicingMAJCOM
      )
      const ownerIntialSqudron = getSquadrons(pascodeMetadata)
      const ownerIntialSqudronOptions = generateSquadronOptions(ownerIntialSqudron)
      const squdronsOptions = generateSquadronOptions(squadrons)
      setintialOptions(
        assignedComponentOptions,
        majcomOptions,
        squdronsOptions,
        sectionOptions,
        categoryOptions,
        majcomOption,
        ownerIntialSqudronOptions
      )
    } else if (isAssignedComponentOwner) {
      const componentCodes = userLoginRole?.usersAssignedComponentCode
      const assignedComponentCodeOptions = generateCodeOptionOnLength(
        assignedComponentOptions,
        componentCodes
      )
      const majcomCodes = majcoms
        .filter((item) => componentCodes?.includes(item.ParentComponentCode))
        .map((item) => item.MAJCOMCode)
      const majcomOption = generateCodeOptionOnLength(majcomOptions, majcomCodes)
      const ownerSquadrons = getSquadrons(pascodeMetadata, undefined, componentCodes)
      const ownerSqudronsOptions = generateSquadronOptions(ownerSquadrons)
      const squadrons = getSquadrons(
        pascodeMetadata,
        undefined,
        componentCodes,
        userProfile[0].ServicingMAJCOM
      )
      const squdronsOptions = generateSquadronOptions(squadrons)
      setintialOptions(
        assignedComponentCodeOptions,
        majcomOption,
        squdronsOptions,
        sectionOptions,
        categoryOptions,
        undefined,
        ownerSqudronsOptions
      )
    } else if (isMAJCOMOwner) {
      const majcomCode = userLoginRole?.usersMajcomCodeFilter
      const profileMajcomCode = getMAJCOMCode(userProfile[0].ServicingMAJCOM, majcoms)
      const majcomCodes = majcomCode.includes(profileMajcomCode)
        ? majcomCode
        : (majcomCode.unshift(profileMajcomCode), majcomCode)

      const componentCodes = majcoms
        .filter((item) => majcomCodes?.includes(item.MAJCOMCode))
        .map((item) => item.ParentComponentCode)
      const assignedComponentCodeOptions = generateCodeOptionOnLength(
        assignedComponentOptions,
        componentCodes
      )
      const majcomOption = generateCodeOptionOnLength(majcomOptions, majcomCodes)
      const majcomNames = majcoms
        .filter((item) => majcomCodes?.includes(item.MAJCOMCode))
        .map((item) => item.Label)
      const squadrons = getSquadrons(
        pascodeMetadata,
        undefined,
        undefined,
        userProfile[0].ServicingMAJCOM
      )
      const squdronsOptions = generateSquadronOptions(squadrons)
      const ownerSquadrons = getSquadrons(
        pascodeMetadata,
        undefined,
        undefined,
        undefined,
        majcomNames
      )
      const ownerSqudronsOptions = generateSquadronOptions(ownerSquadrons)
      setintialOptions(
        assignedComponentCodeOptions,
        majcomOption,
        squdronsOptions,
        sectionOptions,
        categoryOptions,
        undefined,
        ownerSqudronsOptions
      )
    } else if (isLeadership || isMPFOwner) {
      const roleOrganizations =
        userLoginRole?.usersServicingOrganizationWithoutSectionFilter as string[]
      const profileOrganization = userProfile[0].ServicingOrganization
      const organizations = roleOrganizations.includes(profileOrganization)
        ? roleOrganizations
        : (roleOrganizations.unshift(profileOrganization), roleOrganizations)
      const filteredItems: PascodeMetadata[] = getFilteredItems(pascodeMetadata, organizations)
      const { componentCodes, servicingMAJCOMS } = getUniqueCodes(filteredItems)
      const majcomCodes = servicingMAJCOMS.map((item) => getMAJCOMCode(item, majcoms))
      const assignedComponentCodeOptions = generateCodeOptionOnLength(
        assignedComponentOptions,
        componentCodes
      )
      const majcomOption = generateCodeOptionOnLength(majcomOptions, majcomCodes)
      const squadrons = getSquadrons(
        pascodeMetadata,
        undefined,
        undefined,
        userProfile[0].ServicingMAJCOM,
        undefined,
        organizations
      )

      const squdronsOptions = generateSquadronOptions(squadrons)
      const ownerSqudronsOptions = generateSquadronOptions(organizations)
      setintialOptions(
        assignedComponentCodeOptions,
        majcomOption,
        squdronsOptions,
        sectionOptions,
        categoryOptions,
        undefined,
        ownerSqudronsOptions
      )
    } else if (isCSS) {
      const userCSSPASCODES = userLoginRole?.CSSPASCODEFilter
      const userProfilePASCODE = userProfile[0].PASCODE
      const cssPASCODES = userCSSPASCODES.includes(userProfilePASCODE)
        ? userCSSPASCODES
        : (userCSSPASCODES.unshift(userProfilePASCODE), userCSSPASCODES)
      const filteredItems = pascodeMetadata.filter((item) => cssPASCODES?.includes(item.PASCODE))
      const { componentCodes, organizations, servicingMAJCOMS } = getUniqueCodes(filteredItems)
      const majcomCodes = servicingMAJCOMS.map((item) => getMAJCOMCode(item, majcoms))
      const assignedComponentCodeOptions = generateCodeOptionOnLength(
        assignedComponentOptions,
        componentCodes
      )
      const majcomOption = generateCodeOptionOnLength(majcomOptions, majcomCodes)
      const squadrons = getSquadrons(
        pascodeMetadata,
        undefined,
        undefined,
        userProfile[0].ServicingMAJCOM,
        undefined,
        organizations
      )
      const squdronsOptions = generateSquadronOptions(squadrons)
      const ownerSqudronsOptions = generateSquadronOptions(organizations)
      setintialOptions(
        assignedComponentCodeOptions,
        majcomOption,
        squdronsOptions,
        sectionOptions,
        categoryOptions,
        undefined,
        ownerSqudronsOptions
      )
    } else if (isSupervisor || isTechnician || isSectionChief || isSectionOwner) {
      const roleOrganizations = userLoginRole?.usersServicingOrganizationFilter as string[]
      const profileOrganization = userProfile[0].ServicingOrganization
      const organizations = roleOrganizations.includes(profileOrganization)
        ? roleOrganizations
        : (roleOrganizations.unshift(profileOrganization), roleOrganizations)
      const filteredItems = getFilteredItems(pascodeMetadata, organizations)
      const { componentCodes, servicingMAJCOMS } = getUniqueCodes(filteredItems)
      const majcomCodes = servicingMAJCOMS.map((item) => getMAJCOMCode(item, majcoms))
      const assignedComponentCodeOptions = generateCodeOptionOnLength(
        assignedComponentOptions,
        componentCodes
      )
      const majcomOption = generateCodeOptionOnLength(majcomOptions, majcomCodes)
      const squadrons = getSquadrons(
        pascodeMetadata,
        undefined,
        undefined,
        userProfile[0].ServicingMAJCOM,
        undefined,
        organizations
      )
      const squdronsOptions = generateSquadronOptions(squadrons)
      const ownerSqudronsOptions = generateSquadronOptions(organizations)

      const sectionCodes = userLoginRole?.usersSectionCodeFilter as number[]
      const CategoryCodes = categories
        .filter((item) => sectionCodes?.includes(item.ParentSectionCode as number))
        .map((item) => item.CategoryCode)
      const sectionOption = generateCodeOptionOnLength(sectionOptions, sectionCodes)
      const categoryOption = generateCodeOptionOnLength(categoryOptions, CategoryCodes)
      setintialOptions(
        assignedComponentCodeOptions,
        majcomOption,
        squdronsOptions,
        sectionOption,
        categoryOption,
        undefined,
        ownerSqudronsOptions
      )
    } else {
      const componentCode = [userProfile[0].AssignedComponentCode]
      const servicingMAJCOMCode = [getMAJCOMCode(userProfile[0].ServicingMAJCOM, majcoms)]
      const assignedComponentCodeOptions = generateCodeOptionOnLength(
        assignedComponentOptions,
        componentCode
      )
      const majcomOption = generateCodeOptionOnLength(majcomOptions, servicingMAJCOMCode)
      const organizations = [userProfile[0].ServicingOrganization]
      const squdronsOptions = generateSquadronOptions(organizations)

      setintialOptions(
        assignedComponentCodeOptions,
        majcomOption,
        squdronsOptions,
        sectionOptions,
        categoryOptions
      )
    }
  }, [
    isSiteAdmin,
    isCSS,
    isCPOwner,
    isAssignedComponentOwner,
    isMAJCOMOwner,
    pascodeMetadata,
    isCustomer,
  ])
  const [announcements, setAnnouncements] = useState<Announcement[]>([])
  const [intialAnnouncement, setIntialAnnouncement] = useState<Array<DashboardAnnouncement>>([])
  const [filteredAnnouncements, setFilteredAnnouncements] = useState<Array<DashboardAnnouncement>>(
    []
  )
  const [searchAnnouncements, setSearchAnnouncements] = useState<Array<DashboardAnnouncement>>([])
  const [filteredTagAnnouncements, setFilteredTagAnnouncements] = useState<
    Array<DashboardAnnouncement>
  >([])
  const [searchValue, setSearchValue] = useState('')

  function codesNullHandler(code: number) {
    return code ? code : -1
  }

  function newAnnounment(
    componentCode: number,
    majcomCode: number,
    sectionCode: number,
    categoryCode: number,
    squadron: string
  ) {
    const newAnnouncements = intialAnnouncement?.filter(
      ({
        assignComponentCode: aC,
        categoryCode: cC,
        majcomCode: mC,
        sectionCode: sC,
        squadron: squad,
      }) => {
        return (
          filterBy(aC, componentCode) &&
          filterBy(mC, majcomCode) &&
          filterBy(sC, sectionCode) &&
          filterBy(cC, categoryCode) &&
          filterBy(squad, squadron)
        )
      }
    )

    setFilteredAnnouncements(newAnnouncements)
    setSearchAnnouncements(newAnnouncements)
    setFilteredTagAnnouncements(newAnnouncements)
  }
  function onAssignComponentChange(e: { label: string; value: number }) {
    setSearchValue('')
    setIsTagActive(!isTagActive)
    const option: Dropdown[] = majcoms
      .filter(({ ParentComponentCode }) => ParentComponentCode === e.value)
      .map(({ Label, Value }) => ({ label: Label, value: Value }))
    const intialmajcomCodes = intialMajcomDropdown.map(({ value }) => value)
    const options = option.filter(({ value }) => intialmajcomCodes.includes(value as number))
    if (options.length > 1) options.unshift(ALL_SELECT_OPTION)
    setMajcomDropdown(options as optionsTypes[])
    const majcomValue = options.length === 1 ? (options[0].value as number) : ALL_SELECT_VALUE
    // organization
    const pascodes = pascodeMetadata.filter(
      ({ AssignedComponentCode }) => AssignedComponentCode === e.value
    )
    const intialSquadron = intialSquadronDropdown.map(({ value }) =>
      (value as string).replace('FSS', 'MPF')
    )
    const squadrons = [
      ...new Set(
        pascodes
          .filter(({ ServicingOrganization }) =>
            intialSquadron.includes(ServicingOrganization as string)
          )
          .map(({ ServicingOrganization }) => ServicingOrganization)
      ),
    ].sort()
    const squdronsOptions = generateSquadronOptions(squadrons)
    setSquadronDropDown(squdronsOptions as optionsTypes[])
    const squadronValue =
      squdronsOptions.length === 1 ? (squdronsOptions[0].value as string) : ALL_SELECT_VALUE_STRING

    newAnnounment(
      e.value,
      majcomValue,
      inputValues.sectionCode,
      inputValues.categoryCode,
      squadronValue
    )
    setInputValues((prev) => ({
      ...prev,
      assignedComponentCode: e.value,
      majcomCode: majcomValue,
      squadron: squadronValue,
    }))
  }
  function onMajcomChange(e: { label: string; value: number }) {
    setSearchValue('')
    setIsTagActive(!isTagActive)
    // organization
    const pascodes =
      e.label === ALL_SELECT_LABEL
        ? pascodeMetadata
        : pascodeMetadata.filter(({ ServicingMAJCOM }) => ServicingMAJCOM === e.label)
    const intialSquadron = intialSquadronDropdown.map(({ value }) =>
      (value as string).replace('FSS', 'MPF')
    )
    const squdrons = [
      ...new Set(
        pascodes
          .filter(({ ServicingOrganization }) =>
            intialSquadron.includes(ServicingOrganization as string)
          )
          .map(({ ServicingOrganization }) => ServicingOrganization)
      ),
    ].sort()
    const squdronsOptions = generateSquadronOptions(squdrons)
    setSquadronDropDown(squdronsOptions as optionsTypes[])
    const squadronValue =
      squdronsOptions.length === 1 ? (squdronsOptions[0].value as string) : ALL_SELECT_VALUE_STRING
    setInputValues((prevState) => ({
      ...prevState,
      majcomCode: e.value,
      squadron: squadronValue,
    }))
    newAnnounment(
      inputValues.assignedComponentCode,
      e.value,
      inputValues.sectionCode,
      inputValues.categoryCode,
      squadronValue
    )
  }
  function onSquadronChange(e: { label: string; value: string }) {
    setSearchValue('')
    setIsTagActive(!isTagActive)
    setInputValues((prevState) => ({
      ...prevState,
      squadron: e.value,
    }))
    newAnnounment(
      inputValues.assignedComponentCode,
      inputValues.majcomCode,
      inputValues.sectionCode,
      inputValues.categoryCode,
      e.value
    )
  }
  const onSectionChange = (e: { label: string; value: number }) => {
    setSearchValue('')
    setIsTagActive(!isTagActive)
    const option =
      e.value === ALL_SELECT_VALUE
        ? intialCategoryDropdown
        : categories
            .filter(({ ParentSectionCode }) => ParentSectionCode === e.value)
            .map(({ Label, Value }) => ({ label: Label, value: Value }))
    const intialCategoryCodes = intialCategoryDropdown.map(({ value }) => value)
    const options = option.filter(({ value }) => intialCategoryCodes.includes(value as number))
    if (options.length > 0 && e.value !== ALL_SELECT_VALUE) {
      options.unshift(ALL_SELECT_OPTION)
    }
    setCategoryDropDown(options as optionsTypes[])
    newAnnounment(
      inputValues.assignedComponentCode,
      inputValues.majcomCode,
      e.value,
      ALL_SELECT_VALUE,
      inputValues.squadron
    )
    setInputValues((prev) => ({
      ...prev,
      categoryCode: ALL_SELECT_VALUE,
      sectionCode: e.value,
    }))
  }

  const onCategoryChange = (e: { label: string; value: number }) => {
    setSearchValue('')
    setIsTagActive(!isTagActive)
    newAnnounment(
      inputValues.assignedComponentCode,
      inputValues.majcomCode,
      inputValues.sectionCode,
      e.value,
      inputValues.squadron
    )
    setInputValues((prev) => ({
      ...prev,
      categoryCode: e.value,
    }))
  }
  const redirectToHome = () => {
    navigate(`${ROUTE_TYPE}`)
  }

  function onSearchChange(e: { target: { value: string } }) {
    setIsTagActive(!isTagActive)
    setSearchValue(e.target.value)
    const filtered = filteredAnnouncements?.filter((data: DashboardAnnouncement) => {
      const title = data?.title || ''
      const descriptionWithoutHTML = removeTags(data?.content) || ''
      const Attachments: string[] =
        data?.Attachments[0]?.blobs?.flatMap((blob) => blob?.fileName) || []
      const tags = data?.tags || ''
      const sections = data?.section
      const postedDate = data?.postedDate
      const queryLowerCase = e.target.value.toLowerCase()
      return (
        title?.toLowerCase().includes(queryLowerCase) ||
        sections?.some((sec) => sec.toLowerCase().includes(queryLowerCase)) ||
        postedDate?.toLowerCase().includes(queryLowerCase) ||
        Attachments?.some((filename) => filename.toLowerCase().includes(queryLowerCase)) ||
        descriptionWithoutHTML?.toLowerCase().includes(queryLowerCase) ||
        tags?.some((tag) => tag.toLowerCase().includes(queryLowerCase))
      )
    })
    setSearchAnnouncements(filtered)
    setFilteredTagAnnouncements(filtered)
  }
  function onClear() {
    setIsTagActive(!isTagActive)
    setCategoryDropDown(intialCategoryDropdown)
    setMajcomDropdown(intialMajcomDropdown)
    setSquadronDropDown(intialSquadronDropdown)
    setInputValues({
      assignedComponentCode: intialInputValues.componentValue,
      categoryCode: intialInputValues.categoryValue,
      itemKey: '',
      majcomCode: intialInputValues.majcomValue,
      sectionCode: intialInputValues.sectionValue,
      squadron: intialInputValues.squadronValue,
    })
    setSearchValue('')
    newAnnounment(
      intialInputValues.componentValue,
      intialInputValues.majcomValue,
      intialInputValues.sectionValue,
      intialInputValues.categoryValue,
      intialInputValues.squadronValue
    )
  }

  useEffect(() => {
    setAnnouncements(AnnouncementData)
  }, [AnnouncementData])

  useEffect(() => {
    async function getAnnouncementData() {
      if (AnnouncementData.length > 0) {
        await getBlobStorage(Announcementslist, announcements).then((data) => {
          let homeAnnouncement: DashboardAnnouncement[] = data?.map((item, index) => ({
            Attachments: item.Attachments,
            assignComponentCode: codesNullHandler(item.AssignedComponentCode),
            categoryCode: item.CategoryCodes,
            content: item.Description,
            eKey: item.eKey,
            extra: '',
            id: index,
            link: '/announcements',
            majcomCode: codesNullHandler(item.ServicingMAJCOMCode),
            postedDate: formatUTCDateToLocal(item.ItemCreated),
            section: item.Section,
            sectionCode: item.SectionCodes,
            squadron: item.Squadron,
            subcontent: `Posted Date: ${formatUTCDateToLocal(
              item.ItemCreated
            )}  |  Section : ${item.Section.join(', ')}  |  Tags : ${item.Tags} `,
            subcontent1: '',
            tags: item.Tags.split(','),
            title: item.Title,
          }))
          if (location.state && location.state.itemKey) {
            const clickedAnnouncement = homeAnnouncement.find(
              (item) => item.eKey === location.state.itemKey
            )
            const filteredAnnouncements = homeAnnouncement.filter(
              (item) => item.eKey !== location.state.itemKey
            )
            filteredAnnouncements.unshift(clickedAnnouncement)
            homeAnnouncement = filteredAnnouncements
          }

          setIntialAnnouncement(homeAnnouncement)
          const filterIntialItems = homeAnnouncement.filter(
            ({
              assignComponentCode,
              categoryCode,
              majcomCode,
              section,
              sectionCode,
              squadron: squad,
            }) => {
              return (
                filterBy(assignComponentCode, inputValues.assignedComponentCode) &&
                filterBy(majcomCode, inputValues.majcomCode) &&
                filterBy(sectionCode, inputValues.sectionCode) &&
                filterBy(categoryCode, inputValues.categoryCode) &&
                filterBy(squad, inputValues.squadron)
              )
            }
          )
          setFilteredAnnouncements(filterIntialItems)
          setSearchAnnouncements(filterIntialItems)
          setFilteredTagAnnouncements(filterIntialItems)
        })
      }
    }
    getAnnouncementData()
  }, [announcements])

  useEffect(() => {
    // This effect runs whenever the location changes (when the user navigates to a different route)
    if (currentPage !== location.pathname) {
      // User has navigated to a new page, so update the previous page
      setPreviousPage(currentPage) // Store the previous page
      setCurrentPage(location.pathname) // Update the current page
    }
  }, [location, currentPage]) // Runs whenever location or currentPage changes
  return (
    <>
      <PageHeader
        count={filteredTagAnnouncements.length.toString().padStart(2, '0')}
        extras={
          <div className='d-flex flex-wrap align-items-center'>
            <div className='mx-2 mb-1'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-150 min-w-sm-150  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-12 title-color'
                id='AssignedComponent'
                inputProps={{
                  className: 'font-12 poppins-medium title-color',
                }}
                label='Assigned Component'
                name='Assigned Component'
                onChange={onAssignComponentChange}
                options={intialComponentDropdown}
                value={inputValues.assignedComponentCode}
              />
            </div>
            <div className='mx-2 mb-1'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-100 min-w-sm-100  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-12 title-color'
                id='ServicingMAJCOM'
                inputProps={{
                  className: 'font-12 poppins-medium title-color',
                }}
                label='Servicing MAJCOM'
                name='Servicing MAJCOM'
                onChange={onMajcomChange}
                options={majcomDropDown}
                value={inputValues.majcomCode}
              />
            </div>
            <div className='mx-2 mb-1'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-100 min-w-sm-100  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-12 title-color'
                id='ServicingOrganization'
                inputProps={{
                  className: 'font-12 poppins-medium title-color',
                }}
                label='Servicing Organization'
                name='Servicing Organization'
                onChange={onSquadronChange}
                options={squadronDropDown}
                value={inputValues.squadron}
              />
            </div>
            <div className='mx-2 mb-1'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-100 min-w-sm-100  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-12 title-color'
                id='Section'
                inputProps={{
                  className: 'font-12 poppins-medium title-color',
                }}
                label='Section'
                name='Section'
                onChange={onSectionChange}
                options={intialSectionDropdown}
                value={inputValues.sectionCode}
              />
            </div>
            <div className='mx-2 mb-1'>
              <CustomSelect
                className='form-sm w-100 max-w-sm-100 min-w-sm-100  sourcesanspro font-13 customselect'
                formClassName='form-horizontal dash poppins-semibold font-12 title-color'
                id='Category'
                inputProps={{
                  className: 'font-12 poppins-medium title-color',
                }}
                label='Category'
                name='Category'
                onChange={onCategoryChange}
                options={categoryDropDown}
                value={inputValues.categoryCode}
              />
            </div>
            <div className='dividerdashed vertical h-100'></div>
            <div className='mx-2 mb-1'>
              <InputSearch
                aria-label='Search'
                className='border w-100 form-sm border-radius5'
                icon='icon-search pe-2'
                inputProps={{
                  placeholder: 'Search',
                  value: searchValue,
                }}
                onChange={(e: any) => onSearchChange(e)}
                searchgroup=' w-100 d-flex align-items-center inputswithicon'
              />
            </div>

            <div className='ms-2 mb-1 ms-auto'>
              <Buttons
                className='btn btn-sm links ms-auto ms-sm-0 ms-md-0 p-0 links-underline'
                label='Clear All'
                onClick={onClear}
                type='button'
              />
            </div>
            <div className='mx-2 mb-1 d-none'>
              <Buttons
                aria-label='Back'
                className='btn-sm font-14 btn-bgcolor7 whitetext  border-radius text-uppercase'
                icon='icon-left-arrow me-1 font-10'
                label='Back'
                onClick={(e: any) => redirectToHome()}
              />
            </div>
          </div>
        }
        icon='icon-announcements font-14 me-1 color-primary'
        name='Announcements'
      />
      <div className='container my-1'>
        <div className='row'>
          <div className='col-sm-12 col-lg'>
            <div className='card shadow  border-radius2 p-3 h-100'>
              <div className='border-none'>
                {filteredTagAnnouncements.length === 0 ? (
                  <div>
                    <NO_RESULTS />
                  </div>
                ) : (
                  filteredTagAnnouncements?.map((announcement, key) => (
                    <InformationPageList
                      activeClass={announcement.eKey === inputValues.itemKey ? 'bgcolor-64' : ''}
                      key={key}
                      metaData={announcement}
                      page={'Annoucements'}
                      searchValue={searchValue}
                    />
                  ))
                )}
              </div>
            </div>
          </div>
          <div className='col-sm-12 listview-filters order-first order-lg-0'>
            <div className='card shadow  border-radius2 h-100'>
              <TagsCloud
                intialItems={searchAnnouncements}
                isTagActive={isTagActive}
                setFilteredTagItems={setFilteredTagAnnouncements}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default Announcements
